import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { City } from '@city/const';
import { CityService } from '@city/feature';
import { SdModalService, SdvorIconComponent } from '@sdvor/shared/ui/v2';
import { IconTypes } from '@shared/v2/models';
import { Observable, take } from 'rxjs';
import { CitiesDialogComponent } from '../cities-dialog';
import { CitiesNoDeliveryContainerComponent } from '../cities-no-delivery-container';
import { CityDefinedConfirmationComponent } from '../city-defined-confirmation';

@Component({
  selector: 'sd-city-select',
  templateUrl: './city-select.component.html',
  styleUrls: ['./city-select.component.scss'],
  imports: [AsyncPipe, CityDefinedConfirmationComponent, SdvorIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CitySelectComponent {
  currentCity$: Observable<City | undefined> = this.cityService.currentCity$;
  iconTypes = IconTypes;
  @Input() isMobileMenu = false;

  constructor(
    private cityService: CityService,
    private modalService: SdModalService,
    private destroyRef: DestroyRef,
  ) {}

  onOpenCityList(e: MouseEvent): void {
    e.preventDefault();
    this.cityService.currentCity$.pipe(take(1), takeUntilDestroyed(this.destroyRef)).subscribe((currentCity) => {
      const inDeliveryZone = Boolean(currentCity?.inDeliveryZone);

      this.modalService.open(inDeliveryZone ? CitiesDialogComponent : CitiesNoDeliveryContainerComponent, {
        modalType: { xxs: 'fullscreen', lg: 'standard' },
        maxWidth: { lg: inDeliveryZone ? '812px' : '464px' },
      });
    });
  }
}
